export default "__VITE_ASSET__12fc33a4__"